import _ from 'lodash';
import { Box, styled } from '@mui/material';
import { useStatusColors } from '../../../quotes-policies/cards/policyholder/utils';
import {
  LeftBadge,
  ArrowLeft,
} from '../../../quotes-policies/drawers/LeftBadge';
import { withShowable } from '../../../_global/lib/withShowable';
import { getIsRenewalOrMigration } from '../../../../utils';
import { getPolicyStatus } from '../../listing/cowbell/helpers';

export const PolicyHolderPolicyDrawerHeader = ({ policy }: any) => {
  const status = getPolicyStatus(policy);
  const statusColor = useStatusColors(status);
  const isRenewal = _.get(policy, 'isRenewal', false);
  const isMigration = _.get(policy, 'isMigration', false);
  const isRenewalOrMigration = getIsRenewalOrMigration(isRenewal, isMigration);
  const isBinder = status === 'BOUND' && !policy.isAppSigned;

  return (
    <FlexBox width="100%" justifyContent="space-between" alignItems="center">
      <MidtermBadge show={!!policy.isEndorsement}>
        Midterm
        <ArrowLeft />
      </MidtermBadge>
      <RenewalBadge show={isRenewalOrMigration}>
        Renewal
        <ArrowLeft />
      </RenewalBadge>
      <Box height="2rem" width="1rem" />
      <DrawerHeaderText>
        {isBinder
          ? `Binder Number: ${policy.quoteNumber || '-'}`
          : `Policy Number: ${policy.policyNumber || '-'}`}
        <DrawerHeaderSpan
          style={{ color: statusColor }}
        >{`[${status}]`}</DrawerHeaderSpan>
      </DrawerHeaderText>
      <IsSurplusBadge>{policy.isSurplus ? 'S' : 'A'}</IsSurplusBadge>
    </FlexBox>
  );
};

const FlexBox = styled(Box)(() => ({
  display: 'flex',
  position: 'relative',
}));

const DrawerHeaderText = styled('h1')(({ theme: { palette, config } }) => ({
  color: palette.primary.main,
  fontWeight: config.weights.normal,
  margin: 0,
  fontSize: config.textSizes.paragon,
}));

const DrawerHeaderSpan = styled('span')(({ theme: { config } }) => ({
  color: 'green',
  fontSize: config.textSizes.greatPrimer,
  marginLeft: '0.75rem',
  textTransform: 'uppercase',
}));

const IsSurplusBadge = styled(FlexBox)(({ theme: { palette, config } }) => ({
  color: palette.primary.main,
  fontWeight: config.weights.normal,
  margin: 0,
  fontSize: config.textSizes.primer,
  border: `1px solid ${palette.text.text12}`,
  borderRadius: '1rem',
  width: '2rem',
  height: '2rem',
  justifyContent: 'center',
  alignItems: 'center',
}));

const MidtermBadge = withShowable(
  styled(LeftBadge)(({ theme: { palette } }) => ({
    backgroundColor: palette.snackBar.primary,
  }))
);

const RenewalBadge = withShowable(
  styled(LeftBadge)(({ theme: { palette } }) => ({
    backgroundColor: palette.common.cowbellBlue,
  }))
);
